export class EntityMappingManagerMock {
  public forJson(ignore) {
    return {
      getJsonPropertyName: () => 'test-json'
    }
  }
  public forClass(ignore) {
    return {
      getJsonPropertyName: () => 'test-json'
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/entity-mapping-manager/entity-mapping-manager.mock.ts